module.exports = __webpack_public_path__ + "img/upload-email-generic-en.f68bd71c.webp";